import React from 'react'
import MUIDialogTitle from '@material-ui/core/DialogTitle'

export const DialogTitle = props => {
  return <MUIDialogTitle {...props} />
}
